import React from 'react';
import { Field } from 'react-final-form';
import Autocomplete from '@mui/material/Autocomplete';
import { TextField } from '@material-ui/core';

const MUIAutoComplete = ({
    name, variant, label, ...restProps
}) => (
    <Field name={name}>
        {({ input, meta }) => (
            <Autocomplete
                {...restProps}
                {...input}
                renderInput={params => <TextField
                    {...params}
                    label={label}
                    variant={variant}
                    error={meta.error && meta.touched}
                    helperText={meta.touched && meta.error}
                /> }
                onChange={ (e, value) => {
                    input.onChange(value);
                }}
            />
        )}
    </Field>
);

export default MUIAutoComplete;

